import React, { useState, useImperativeHandle } from 'react'
import { useFormik, FormikProvider, FieldArray } from 'formik'
import moment from 'moment';

// components
import InputField from '../../../../../components/forms/InputField/InputField.component';
import FormDataPoint from '../../../../../components/forms/FormDataPoint/FormDataPoint.component';
import FormSectionHeader from '../../../../../components/forms/FormSectionHeader/FormSectionHeader.component';
import AsyncSelectField from '../../../../../components/forms/AsyncSelectField/AsyncSelectField.component';
import ActionButton from '../../../../../components/buttons/ActionButton/ActionButton.component';
import ReceivingEquipmentInput from '../../../../../components/forms/lists/ReceivingEquipmentInput/ReceivingEquipmentInput.component';

// queries
import { GET_ALL_JOBS_FOR_SELECT_FIELD } from '../../../../../graphql/job/job.queries';
import { GET_ALL_EQUIPMENT_FOR_SELECT_FIELD } from '../../../../../graphql/equipment/equipment.queries';

const ReceivingFromJobSite = React.forwardRef(({ stage, errors }, ref) => {
    const [ selectedJob, setSelectedJob ] = useState(null)
    const [ selectedEquipment, setSelectedEquipment ] = useState(null)

    useImperativeHandle(ref, () => ({
        getData: () => { return formik.values }
    }))

    const formik = useFormik({
        initialValues: {
            forJob: '',
            date: moment(),
            time: moment(),
            equipment: [],
            equipmentSearch: '',
        },
        onSubmit: values=> {
            alert(JSON.stringify(values, null, 2));
        },
    });

    const stage0 = (<React.Fragment>

            <AsyncSelectField 
                id="job"
                value={formik.values.forJob}
                onChange={value => {
                    formik.setFieldValue('forJob', value.value)
                    setSelectedJob(value.data)
                }}
                placeholder="Select a Job (required)"
                query={{
                    query: GET_ALL_JOBS_FOR_SELECT_FIELD,
                    rules: {
                        loopField: 'allJobs',
                        label: ['name'],
                        value: 'id'
                    }
                    
                }}
                isValid={errors['forJob']}
            />

            <InputField 
                id="date"
                placeholder="Date"
                type="date"
                onChange={value => formik.setFieldValue('date', value)}
                value={formik.values.date}
                isValid={errors['date']}
            />

            <InputField 
                id="time"
                placeholder="Time"
                type="time"
                onChange={value => formik.setFieldValue('time', value)}
                value={formik.values.time}
                isValid={errors['time']}
            />
        </React.Fragment>)

    const stage1 = (<React.Fragment>
            <FormDataPoint label='Job' value={selectedJob ? selectedJob.name : null} />
            

            <FieldArray 
                name='equipment'
                render={({ remove, push }) => (
                    <div>
                        <FormSectionHeader text='Equipment' />
                        <div className='select-and-add'>
                            <div className='select-and-add-left'>
                                <AsyncSelectField 
                                    id="equipmentSearch"
                                    value={formik.values.equipmentSearch}
                                    placeholder="Search"
                                    onChange={value => { 
                                        setSelectedEquipment(value.data)
                                        formik.setFieldValue('equipmentSearch', value.value)
                                    }}
                                    query={{
                                        query: GET_ALL_EQUIPMENT_FOR_SELECT_FIELD,
                                        rules: {
                                            loopField: 'allEquipment',
                                            label: ['sku', 'name'],
                                            value: 'id',
                                            groupBy: 'category.name'
                                        }
                                    }}
                                    grouped
                                    showRequired={false}
                                />
                            </div>
                            <div className='select-and-add-right'>
                                <ActionButton label='Add' disabled={selectedEquipment == null} onClick={(e) => {
                                    e.preventDefault();
                                    push({...selectedEquipment, quantityReceived: ''})
                                }} />
                            </div>
                        </div>

                        {
                            formik.values.equipment.map((item, index) => {
                                return (<ReceivingEquipmentInput 
                                    key={index}
                                    prefix={`equipment.${index}`}
                                    handleChange={formik.handleChange}
                                    title={item.name}
                                    subTitle={null}
                                    qtyReceived={item.quantityReceived}
                                    errors={errors['equipment'].length > index ? errors['equipment'][index] : {}}
                                    handleRemove={(e) => {
                                        e.preventDefault()
                                        remove(index)
                                    }}
                                />)
                            })
                        }
                    </div>
                )}
            />
        </React.Fragment>)
    return (<FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>

            { stage == 0 && stage0 }
            { stage == 1 && stage1 }

            
        </form>
    </FormikProvider>)
})

export default ReceivingFromJobSite